/**
 * Index.ts
 * @author Abhilash Panwar (abpanwar)
 * @copyright Microsoft 2018
 * File to export public classes, interfaces and enums.
 */
import "@microsoft/applicationinsights-shims";
import {
    ValueKind, EventLatency, EventPersistence, TraceLevel, EventPropertyType, _ExtendedInternalMessageId, GuidStyle, FieldValueSanitizerType,
} from "./Enums";
import {
    IExtendedConfiguration, IPropertyStorageOverride,
    IEventProperty, IExtendedTelemetryItem, IExtendedAppInsightsCore, IEventTiming,
    IValueSanitizer, FieldValueSanitizerFunc, IFieldSanitizerDetails, IFieldValueSanitizerProvider,
    FieldValueSanitizerTypes,
} from "./DataModels";
import * as Utils from "./Utils";
import AppInsightsCore from "./AppInsightsCore";
import BaseCore from "./BaseCore";
import ESPromise, { ESPromiseOnResolvedFunc, ESPromiseOnRejectedFunc, ResolverResolveFunc, ResolverRejectFunc } from "./ESPromise";
import ESPromiseScheduler, { ESPromiseSchedulerEvent } from "./ESPromiseScheduler";
import { ValueSanitizer } from "./ValueSanitizer";

export {
    ValueKind, IExtendedConfiguration, IPropertyStorageOverride, Utils,
    EventLatency, EventPersistence, TraceLevel, IEventProperty, IExtendedTelemetryItem,
    AppInsightsCore, BaseCore, _ExtendedInternalMessageId, IExtendedAppInsightsCore, EventPropertyType,
    IEventTiming, ESPromise, ESPromiseOnResolvedFunc, ESPromiseOnRejectedFunc, ResolverResolveFunc,
    ResolverRejectFunc, ESPromiseScheduler, ESPromiseSchedulerEvent, GuidStyle,
    FieldValueSanitizerFunc, FieldValueSanitizerType, FieldValueSanitizerTypes, IFieldSanitizerDetails,
    IFieldValueSanitizerProvider, IValueSanitizer, ValueSanitizer,
};

export {
    IAppInsightsCore, IChannelControls, IPlugin, INotificationManager, NotificationManager, INotificationListener,
    IConfiguration, ITelemetryItem, ITelemetryPlugin, BaseTelemetryPlugin, IProcessTelemetryContext, ProcessTelemetryContext, ITelemetryPluginChain,
    MinChannelPriorty, EventsDiscardedReason, CoreUtils, IDiagnosticLogger, DiagnosticLogger, LoggingSeverity, SendRequestReason,
    hasWindow, getWindow, hasDocument, getDocument, hasNavigator, getNavigator, hasHistory, getHistory, hasJSON, getJSON,
    IPerfEvent, IPerfManager, IPerfManagerProvider, PerfEvent, PerfManager, doPerf,
    getGlobal, getGlobalInst, getPerformance, getLocation, EventHelper, objForEachKey, proxyAssign, getCrypto,
} from "@microsoft/applicationinsights-core-js";

export {
    isValueAssigned, isArray, isObject, isBeaconsSupported, isBoolean, isLatency, isNumber, isReactNative,
    isString, isUint8ArrayAvailable, getISOString, cookieAvailable, getTenantId, sanitizeProperty,
    Version, FullVersionString, getCommonSchemaMetaData, getCookie, setCookie, deleteCookie,
    extend, createGuid, useXDomainRequest, isDocumentObjectAvailable, isWindowObjectAvailable, objDefineAccessors,
    addPageUnloadEventListener, addEventHandler, setProcessTelemetryTimings, getTime, objKeys, arrForEach,
    isFunction, disallowsSameSiteNone, strObject, strUndefined, strUndefined as Undefined, strTrim, isArrayValid, isValueKind,
    getFieldValueType, strEndsWith,
} from "./Utils";
